"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createUserSession = createUserSession;
exports.fetchUserSession = fetchUserSession;
exports.resetUserSession = resetUserSession;
exports.updateUserSession = updateUserSession;
exports.updateUserSessionApiCall = updateUserSessionApiCall;
exports.watchUserSession = watchUserSession;
var _effects = require("redux-saga/effects");
var _userSelectors = require("./userSelectors");
var _questionnaireSelectors = require("../questionnaire/questionnaireSelectors");
var _userActions = require("./userActions");
var _constants = require("../../utils/constants");
var _userMapper = require("./userMapper");
var _questionnaireUtil = require("../../utils/questionnaireUtil");
var _services = require("../../services");
var _errorSelectors = require("../error/errorSelectors");
var _errorActions = require("../error/errorActions");
var _widgetSelectors = require("../widget/widgetSelectors");
var _questionnaireActions = require("../questionnaire/questionnaireActions");
var _logger = require("../../services/logger");
/**
 * CREATE USER SESSION
 */
const logError = e => _logger.Logger.error({
  segments: [_logger.Logger.LOGGER_SEGMENTS.SAGAS]
})(e);
function createUserSession(_ref) {
  let {
    type,
    payload,
    instanceId
  } = _ref;
  return function* () {
    try {
      const {
        marketingId
      } = payload;
      const url = `${_constants.API_PATH.GS_JOURNEY}/journeySession`;
      const response = yield (0, _effects.call)(_services.Services.http.post, url, (0, _userMapper.createUserSessionRequestDTO)(marketingId));
      _services.Services.host.setMarketingId(_services.Services.host.marketingId);
      yield (0, _effects.put)({
        type: _userActions.CREATE_USER_SESSION_SUCCESS,
        payload: {
          marketingId,
          userSession: response
        },
        instanceId: instanceId
      });
    } catch (e) {
      logError(e);
      const currentPage = yield (0, _effects.select)((0, _errorSelectors.selectCurrentPage)(instanceId));
      yield (0, _effects.put)({
        ...(0, _errorActions.setApiCallError)({
          actionToRetry: {
            type,
            payload
          },
          pageToReturnTo: currentPage
        }),
        instanceId: instanceId
      });
    }
  }();
}
/**
 * FETCH USER SESSION
 */

function fetchUserSession(_ref2) {
  let {
    type,
    payload,
    instanceId
  } = _ref2;
  return function* () {
    try {
      var _response;
      const {
        marketingId
      } = payload;
      _logger.Logger.info({
        segments: [_logger.Logger.LOGGER_SEGMENTS.SAGAS]
      })('MARKETING ID', marketingId);
      const url = `${_constants.API_PATH.GS_JOURNEY}/journeySession?relatedParty.role=MarketingID&relatedParty.id=${marketingId}`;
      let response = [];
      response = yield (0, _effects.call)(_services.Services.http.get, url);
      const userSession = (_response = response) === null || _response === void 0 ? void 0 : _response[0];
      yield (0, _effects.put)({
        type: _userActions.FETCH_USER_SESSION_SUCCESS,
        payload: {
          marketingId,
          userSession
        },
        instanceId: instanceId
      });
    } catch (e) {
      logError(e);
      const currentPage = yield (0, _effects.select)((0, _errorSelectors.selectCurrentPage)(instanceId));
      yield (0, _effects.put)({
        ...(0, _errorActions.setApiCallError)({
          actionToRetry: {
            type,
            payload
          },
          pageToReturnTo: currentPage
        }),
        instanceId: instanceId
      });
    }
  }();
}

/**
 * SAVE USER SESSION
 */

function* updateUserSessionApiCall(nextQuestionIndex, instanceId) {
  const processFlowId = yield (0, _effects.select)((0, _userSelectors.selectProcessFlowId)(instanceId));
  const metadata = yield (0, _effects.select)((0, _questionnaireSelectors.selectMetadata)(instanceId));
  const categoryPriceTypes = yield (0, _effects.select)((0, _widgetSelectors.selectCategoryPriceTypes)(instanceId));
  const stateMetadata = (0, _questionnaireUtil.createStateMetadata)(metadata, categoryPriceTypes);
  const sessionState = yield (0, _effects.select)(state => (0, _userSelectors.selectUserSessionState)(instanceId)(state, stateMetadata, nextQuestionIndex));
  const requestDTO = (0, _userMapper.updateUserSessionRequestDTO)(sessionState);
  const url = `${_constants.API_PATH.GS_JOURNEY}/journeySession/update?id=${processFlowId}`;
  return yield (0, _effects.call)(_services.Services.http.post, url, requestDTO);
}
function updateUserSession(_ref3) {
  let {
    type,
    payload,
    instanceId
  } = _ref3;
  return function* () {
    try {
      const {
        nextQuestionIndex
      } = payload;
      const response = yield (0, _effects.call)(updateUserSessionApiCall, nextQuestionIndex, instanceId);
      yield (0, _effects.put)({
        type: _userActions.SAVE_USER_SESSION_SUCCESS,
        payload: {
          userSession: response
        },
        instanceId: instanceId
      });
      if (nextQuestionIndex !== -1) yield (0, _effects.put)({
        type: _questionnaireActions.SET_VIEW_QUESTION_TAGS,
        instanceId: instanceId
      });
    } catch (e) {
      if ((e === null || e === void 0 ? void 0 : e.message) !== _constants.DUPLICATE_REQUEST_CANCELLATION) {
        logError(e);
        const currentPage = yield (0, _effects.select)((0, _errorSelectors.selectCurrentPage)(instanceId));
        yield (0, _effects.put)({
          type: _userActions.SAVE_USER_SESSION_ERROR,
          instanceId: instanceId
        });
        yield (0, _effects.put)({
          ...(0, _errorActions.setApiCallError)({
            actionToRetry: {
              type,
              payload
            },
            pageToReturnTo: currentPage
          }),
          instanceId: instanceId
        });
      }
    }
  }();
}
function resetUserSession(_ref4) {
  let {
    type,
    payload,
    instanceId
  } = _ref4;
  return function* () {
    try {
      const processFlowId = yield (0, _effects.select)((0, _userSelectors.selectProcessFlowId)(instanceId));
      const requestDTO = (0, _userMapper.updateUserSessionRequestDTO)();
      const url = `${_constants.API_PATH.GS_JOURNEY}/journeySession/update?id=${processFlowId}`;
      const response = yield (0, _effects.call)(_services.Services.http.post, url, requestDTO);
      yield (0, _effects.put)({
        type: _userActions.SAVE_USER_SESSION_SUCCESS,
        payload: {
          userSession: response
        },
        instanceId: instanceId
      });
      yield (0, _effects.put)({
        type: _questionnaireActions.SET_VIEW_QUESTION_TAGS,
        instanceId: instanceId
      });
    } catch (e) {
      if ((e === null || e === void 0 ? void 0 : e.message) !== _constants.DUPLICATE_REQUEST_CANCELLATION) {
        logError(e);
        const currentPage = yield (0, _effects.select)((0, _errorSelectors.selectCurrentPage)(instanceId));
        yield (0, _effects.put)({
          type: _userActions.SAVE_USER_SESSION_ERROR,
          instanceId: instanceId
        });
        yield (0, _effects.put)({
          ...(0, _errorActions.setApiCallError)({
            actionToRetry: {
              type,
              payload
            },
            pageToReturnTo: currentPage
          }),
          instanceId: instanceId
        });
      }
    }
  }();
}
function* watchUserSession() {
  yield (0, _effects.takeEvery)(_userActions.CREATE_USER_SESSION, createUserSession);
  yield (0, _effects.takeEvery)(_userActions.FETCH_USER_SESSION, fetchUserSession);
  yield (0, _effects.takeEvery)(_userActions.SAVE_USER_SESSION, updateUserSession);
  yield (0, _effects.takeEvery)(_userActions.RESET_USER_SESSION, resetUserSession);
}